import BaseAPIClient from '../base/BaseAPIClient';

export default class CrisisClient extends BaseAPIClient {
    getCrisisCasesReport(pageToken, from = null, through = null, searches = null, recordCount = 20) {
        return this._get('v2/crisis/cases/bettermynd-clinicalops/', {
            pageToken,
            from,
            through,
            searches,
            recordCount
        });
    }

    setCrisisCaseNotes(caseId, internalExplainer = null, externalExplainer = null) {
        return this._post('v2/crisis/explainers', {
            caseId,
            internalExplainer,
            externalExplainer
        });
    }

    setCrisisCaseInstitution(caseId, institutionId = null) {
        return this._post('v2/crisis/institutions', {
            caseId,
            institutionId
        });
    }

    getCrisisCasesAggregates(onlyUnassignedInstitutions = null, institutionId = null, from = null, through = null) {
        return this._get('v2/crisis/cases/aggregates/', {
            onlyUnassignedInstitutions,
            institutionId,
            from,
            through
        });
    }

    getCrisisCasesInstitutions() {
        return this._get('v2/crisis/institutions/', {});
    }
}
